import * as types from "@/store/types";

const state = {
  categories: [],
  hints: [],
  list: [],
  paginatePages: 1,
  paginateItems: 10,
  paginatePerPage: 20
};

const getters = {
  [types.ticket.getters.categories]: state => {
    return state.categories;
  },

  [types.ticket.getters.hints]: state => {
    return state.hints;
  },

  [types.ticket.getters.list]: state => {
    return state.list;
  },

  [types.ticket.getters.paginatePages]: state => {
    return state.paginatePages;
  },

  [types.ticket.getters.paginateItems]: state => {
    return state.paginateItems;
  },

  [types.ticket.getters.paginatePerPage]: state => {
    return state.paginatePerPage;
  }
};

const mutations = {
  [types.ticket.mutations.setCategories]: (state, payload) => {
    state.categories = payload;
  },

  [types.ticket.mutations.setHints]: (state, payload) => {
    state.hints = payload;
  },

  [types.ticket.mutations.setList]: (state, payload) => {
    state.list = payload;
  },

  [types.ticket.mutations.add]: (state, payload) => {
    state.list = [payload, ...state.list];
  },

  [types.ticket.mutations.setPaginatePages]: (state, payload) => {
    state.paginatePages = payload;
  },

  [types.ticket.mutations.setPaginateItems]: (state, payload) => {
    state.paginateItems = payload;
  },

  [types.ticket.mutations.setPaginatePerPage]: (state, payload) => {
    state.paginatePerPage = payload;
  }
};

const actions = {
  [types.ticket.actions.setCategories]: ({ commit }, payload) => {
    commit(types.ticket.mutations.setCategories, payload);
  },

  [types.ticket.actions.setHints]: ({ commit }, payload) => {
    commit(types.ticket.mutations.setHints, payload);
  },

  [types.ticket.actions.setList]: ({ commit }, payload) => {
    commit(types.ticket.mutations.setList, payload);
  },

  [types.ticket.actions.add]: ({ commit }, payload) => {
    commit(types.ticket.mutations.add, payload);
  },

  [types.ticket.actions.setPaginatePages]: ({ commit }, payload) => {
    commit(types.ticket.mutations.setPaginatePages, payload);
  },

  [types.ticket.actions.setPaginateItems]: ({ commit }, payload) => {
    commit(types.ticket.mutations.setPaginateItems, payload);
  },

  [types.ticket.actions.setPaginatePerPage]: ({ commit }, payload) => {
    commit(types.ticket.mutations.setPaginatePerPage, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
